import { onBeforeUnmount, onMounted, ref } from "vue";

export const width = 1920;
export const height = 1080;

export const useResize = (options = {}) => {
  const {
    w = width,
    h = height,
    fullScreen = false,
    delay = 100,
  } = options;

  const screenRef = ref(null);
  const scale = ref(1);

  const resize = () => {
    if (!screenRef.value) {
      return;
    }

    const clientWidth = document.body.clientWidth;
    const clientHeight = document.body.clientHeight;
    const scaleW = clientWidth / w;
    const scaleH = clientHeight / h;

    scale.value = clientWidth / clientHeight > w / h ? scaleH : scaleW;
    screenRef.value.style.transform = fullScreen
      ? `scale(${scaleW}, ${scaleH})`
      : `scale(${scale.value})`;
  };

  const resizeDelay = debounce(resize, delay);

  onMounted(() => {
    resize();
    window.addEventListener("resize", resizeDelay);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", resizeDelay);
  });

  return {
    scale,
    screenRef,
  };
};

function debounce(callback, delay) {
  let timerId = null;

  return function debounced(event) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      callback.call(null, event);
      timerId = null;
    }, delay);
  };
}
